module.exports = __webpack_public_path__ + "Roboto-BoldItalic.d23d5bdadc495f12ef69.ttf";


//////////////////
// WEBPACK FOOTER
// ./~/roboto-fontface/fonts/Roboto/Roboto-BoldItalic.ttf
// module id = 87
// module chunks = 11